import ChoosePlan from "pages/User/ChoosePlan/index.page";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.CHOOSE_PLAN.path,
      name: "CHOOSEPLAN",
      key: routesMap.CHOOSE_PLAN.path,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <ChoosePlan />,
    },
  ];
}
